import { render, staticRenderFns } from "./CollectionsAgent.vue?vue&type=template&id=a63370ee&scoped=true"
import script from "./CollectionsAgent.vue?vue&type=script&lang=js"
export * from "./CollectionsAgent.vue?vue&type=script&lang=js"
import style0 from "./CollectionsAgent.vue?vue&type=style&index=0&id=a63370ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63370ee",
  null
  
)

export default component.exports